import axios from 'axios';
import { endpoints } from '@api/apis';
import { getApplicationId } from '@screens/FetchPortfolio/utils';

export type PledgeSaveV2Action = 'PREVIEW_FUNDS' | 'SAVE_LIMIT' | 'CONFIRM_FUNDS';

export type FundSelection = {
  isinNo: string;
  folioNo: string;
  pledgedAmount: number;
};

// POST /app/borrower/application/pledge/save/v2/{applicationId}
export const pledgeSaveV2APICall = async <T = unknown>(payload: {
  applicationId: string;
  action: PledgeSaveV2Action;
  requestCreditLimit: number;
  fundSelections?: FundSelection[];
}) => {
  const applicationId = await getApplicationId(payload.applicationId);
  return axios.post<T>(`${endpoints.pledgeSaveV2}${applicationId}`, {
    action: payload.action,
    requestCreditLimit: payload.requestCreditLimit,
    ...(payload.fundSelections ? { fundSelections: payload.fundSelections } : {}),
  });
};
